import { attr, Model } from 'redux-orm';
import { AppAction } from 'src';
import { IORMModels, ISession } from 'src/Config/ConfigureOrm';
import {
  SET_USER_TOKEN,
  GET_USER_DETAILS_SUCCEEDED,
  GET_USER_DETAILS_FAILED,
  SET_USER_FROM_TOKEN,
  GET_USER_PORTAL_DETAILS_SUCCEEDED,
  GET_USER_PORTAL_DETAILS_FAILED,
  WEB_SET_USER_FAVORITE_FAILED,
  WEB_SET_USER_FAVORITE_SUCCEEDED,
  WEB_SET_USER_FAVORITE,
  WEB_SET_USER_TOPICS_SUCCEEDED,
  TOGGEL_SHOW_USER_INTERESTS
} from './User.Actions';
import { SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION } from 'constants';
import { IActivityModel } from '../Activity/Activity';
import { AuthHelper } from 'src/helpers/AuthHelper';

export interface IUserPortalDetails {
  topicInterests?: string[];
  courseFavorites: string[];
  comingCourses?: IComingCourses[];
  openEvaluations?: IEvaluation[];
}
export interface IEvaluation {
  questionnaireTitle: string;
  questionnaireLink: string;
}

export interface IComingCourses {
  detailKursusId: number;
  activity: Pick<IActivityModel, 'courseTitle' | 'startDate' | 'startTime'>;
  enrollmentStatus: string;
}

export interface IUserColumns {
  id: number;
  userId: string;
  personId?: number;
  token?: string;
  forbundId?: number;
  union?: string;
  arrangoerId?: number;
  department?: string;
  cprnr?: string;
  name: string;
  address?: string;
  zip?: string;
  city?: string;
  mobile?: string;
  telefonWork?: string;
  telefonPrivate?: string;
  email?: string;
  showInterests: boolean;
  portalDetails: IUserPortalDetails;
  isAdministrator: boolean;

  errorMsg?: string;
  topicsDidSave: boolean;
}

export default class User extends Model<IUserColumns> implements IUserColumns {
  public static modelName = 'User';
  public static fields = {
    id: attr({}),
    userid: attr({}),
    personId: attr({}),
    token: attr({}),
    forbundid: attr({}),
    cprnr: attr({}),
    name: attr({}),
    address: attr({}),
    zip: attr({}),
    city: attr({}),
    mobile: attr({}),
    telefonWork: attr({}),
    telefonPrivate: attr({}),
    email: attr({}),
    isAdministrator: attr({}),
    errorMsg: attr({})
  };

  public static reducer(
    action: AppAction<any>,
    user: typeof Model,
    session: ISession<IORMModels>
  ) {
    switch (action.type) {
      case SET_USER_TOKEN:
        AuthHelper.SetUserToken(action.payload);
        user.upsert<IUserColumns>({ id: 0, token: action.payload });
        break;
      case SET_USER_FROM_TOKEN:
        user.upsert<IUserColumns>({ id: 0, userId: action.payload });
        break;
      case GET_USER_DETAILS_SUCCEEDED:
        user.upsert<IUserColumns>({ id: 0, ...action.payload });
        break;
      case GET_USER_PORTAL_DETAILS_SUCCEEDED:
        user.upsert<IUserColumns>({ id: 0, portalDetails: action.payload });
        break;
      case WEB_SET_USER_FAVORITE_SUCCEEDED:
        // alert("SET FAVORITES" + action.payload)
        break;
      case WEB_SET_USER_TOPICS_SUCCEEDED:
        user.upsert<IUserColumns>({ id: 0, topicsDidSave: true });
        break;
      case TOGGEL_SHOW_USER_INTERESTS:
        user.upsert<IUserColumns>({ id: 0, showInterests: action.payload });
        break;
      case GET_USER_DETAILS_FAILED ||
        GET_USER_PORTAL_DETAILS_FAILED ||
        WEB_SET_USER_FAVORITE_FAILED:
        // alert("UserFAIL" + action.payload);
        break;
    }
  }

  public id: number;
  public userId: string;
  public personId?: number;
  public token?: string;
  public forbundId?: number;
  public union?: string;
  public arrangoerId?: number;
  public department?: string;
  public cprnr: string;
  public name: string;
  public address: string;
  public zip: string;
  public city: string;
  public mobile: string;
  public telefonWork: string;
  public telefonPrivate: string;
  public email: string;
  public errorMsg: string;
  public topicsDidSave: boolean;
  public portalDetails: IUserPortalDetails;
  public showInterests: boolean;
  public isAdministrator: boolean;
}



// WEBPACK FOOTER //
// ./src/Entities/User/User.ts